import { Component, inject } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'lib-instructions',
  imports: [MarkdownModule, ButtonModule],
  template: `
    <div class="markdownContainer m-8">
      <markdown [src]="instructions" class="prose" />
    </div>
    <div class="footer-bar flex justify-end">
      <p-button
        label="Ok"
        [text]="true"
        [fluid]="true"
        class="w-30"
        (click)="dialogRef.close()"
      ></p-button>
    </div>
  `,
})
export class InstructionComponent {
  protected readonly dialogRef = inject(DynamicDialogRef);

  protected readonly instructions = `/assets/json-e-documentation.md`;
}
